'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$() {
  this.aCa = null;
  this.aCb = false;
}
export { $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ as $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ };
$p = $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$;
/** @constructor */
function $h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$() {
}
export { $h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ as $h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ };
$h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$.prototype = $p;
$p.aA = (function() {
  if ((!this.aCb)) {
    this.aCa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aCb = true;
  }
  return this.aCa;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$, "app.data.OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$", ({
  Ec: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ as $d_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ };
var $n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$;
function $m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$() {
  if ((!$n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$)) {
    $n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ = new $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$();
  }
  return $n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$;
}
export { $m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ as $m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$ };
//# sourceMappingURL=app.data.-Organization-About-Us-Blurb$package$-Organization-About-Us-Blurb$.js.map
